import { ReportStationSummaryDtoSchema } from "@report/data/dto/report-station.dto.ts";
import * as z from "zod";

const ReportPoisRouteRowDtoSchema = z
    .object({
        arrived_time: z.number().nullable(),
        date: z.string().trim(),
        destination_poi: z.number().nullable(),
        from_destination_at: z.number().nullable(),
        from_origin_at: z.number().nullable(),
        origin_poi: z.number(),
        poi_time: z.number().nullable(),
        route: z.number(),
        to_destination_at: z.number().nullable(),
    })
    .readonly();

const ReportStationPoisRouteTotalDtoSchema = z
    .object({
        moving_time: z.number(),
        stopped_time: z.number(),
    })
    .readonly();

const ReportStationPoisRoutesDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.array(ReportPoisRouteRowDtoSchema),
        station: ReportStationSummaryDtoSchema,
        totals: ReportStationPoisRouteTotalDtoSchema,
    })
    .readonly();

export const ReportPoisRoutesDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.record(z.string(), ReportStationPoisRoutesDtoSchema),
        target_stations: z
            .record(z.string(), ReportStationSummaryDtoSchema)
            .optional(),
    })
    .readonly();

export type ReportPoisRoutesDto = z.output<typeof ReportPoisRoutesDtoSchema>;
